import { render } from "./initializedDeliveryOrdersMenu.vue?vue&type=template&id=453308c5"
import script from "./initializedDeliveryOrdersMenu.vue?vue&type=script&lang=js"
export * from "./initializedDeliveryOrdersMenu.vue?vue&type=script&lang=js"

import "./initializedDeliveryOrdersMenu.vue?vue&type=style&index=0&id=453308c5&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__